import axios from "axios"
import {options} from "../Constants/Content"
import {bsUrl} from "../Constants/Content";
import {imgUrl} from "../Constants/Content";
import "./Banner.css"
import { useEffect, useState } from "react";
function Banner() {
  
  
  const [movie,setMovie]=useState()
  useEffect(() => {
    axios.get(bsUrl,options).then((res)=>{
      console.log(res.data.results[0].title)
      setMovie(res.data.results[Math.floor(Math.random()*20)])
     })
  }, [])
  
  
  return (
    <div className="banner" id="home" style={{backgroundImage:`URL(${movie?imgUrl+movie.backdrop_path:""})`}}>
      <div className="content">
        <h1>{movie?movie.title:""}</h1>

        <div className="buttons">
            <button>Play</button>
            <button>My List</button>
        </div>
        <h4>{movie?movie.overview:""}</h4>
      </div>


      <div className="fade">
      </div>
    </div>
  )
}

export default Banner